/* @license
 * Copyright (c) 2026 k1pp0
 * SPDX-License-Identifier: MIT
 *
 * Icon: Lucide "x"
 * Source: https://github.com/lucide-icons/lucide
 * Copyright Lucide Contributors, ISC License
 */
import { html } from 'lit';
export default html `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  <path d="M18 6 6 18"/>
  <path d="m6 6 12 12"/>
</svg>
`;
//# sourceMappingURL=capture-close-svg.js.map